module.exports = __webpack_public_path__ + "img/psqtpe24231clrnpw3quljiwoeaoiwlkpeff4bea8-c4b3-404d-8914-4cba22618ecc.8d3cd136.png";